namespace h5_vm {
   import IController = angular.IComponentController;

   class VmProvisioningDeploymentOptionsController implements IController {
      static $inject: string[] = ["$scope", "vmProvisioningDeploymentOptionsService"];

      private deploymentOptionParams: any;

      constructor(private $scope: any, private vmProvisioningDeploymentOptionsService: any) {
         this.deploymentOptionParams = this.$scope.vmProvisioningDeploymentConfigPageModel.form.deploymentOptionParams;
      }

      public $onInit() {
         this.vmProvisioningDeploymentOptionsService
               .figureOutTheItemSelectedInDeploymentOptions(this.deploymentOptionParams);
      }

      onSelectionChange(selectedOption: any): void {
         this.deploymentOptionParams.selectedKey = selectedOption.key;
      }
   }

   angular.module("com.vmware.vsphere.client.vm")
         .controller("vmProvisioningDeploymentOptionsController", VmProvisioningDeploymentOptionsController);
}

